import { TableHead, TableRow } from '@ksyos/design-system';
import type { IStepGroup, OutclinicDashboardServiceCode } from '@common/interfaces/api/outclinicDashboardApi';
import { OutclinicDashboardTableColumnHeader } from './OutclinicDashboardTableColumnHeader';
import { OutclinicDashboardTableRowHeader } from './OutclinicDashboardTableRowHeader';

interface IOutclinicDashboardTableHeaderProps {
    groups: IStepGroup[];
    serviceCode: OutclinicDashboardServiceCode;
}

export function OutclinicDashboardTableHeader(props: IOutclinicDashboardTableHeaderProps) {
    return (
        <TableHead>
            <TableRow>
                <OutclinicDashboardTableRowHeader isColumnHeader={true} />
                {props.groups.map((group) => (
                    <OutclinicDashboardTableColumnHeader
                        colSpan={group.steps.length}
                        key={group.title}
                        label={group.title}
                    />
                ))}
            </TableRow>
            <TableRow>
                <OutclinicDashboardTableRowHeader
                    isColumnHeader={true}
                    label="PID"
                />
                {props.groups.map((group) =>
                    group.steps.map((step, stepIndex) => (
                        <OutclinicDashboardTableColumnHeader
                            hasSolidBorder={stepIndex === group.steps.length - 1}
                            key={`${step.id}-${stepIndex}`}
                            label={step.dashboardNameShort || step.dashboardName}
                        />
                    ))
                )}
            </TableRow>
        </TableHead>
    );
}
